import { createContext } from 'react';

export const mappingLayerContext = {};

export default createContext(mappingLayerContext);
